import {defer, map, Observable, switchMap, tap} from 'rxjs';
import {connectWalletConnectWallets, connectMetaMaskWallet, suppportConnectors, type SupportConnectors} from './connectors';
import {web3Api} from '@/api/web3';
import {signMessage} from './signer';

/**
 * 创建从用户连接钱包，到生成钱包地址操作的Observable
 */
export function createGetWalletObservable(connector: SupportConnectors) {
  if (connector === suppportConnectors.metaMask) {
    return defer(connectMetaMaskWallet);
  }
  if (connector === suppportConnectors.walletConnect) {
    return defer(connectWalletConnectWallets);
  }
}

/**
 * 创建获取签名操作的Observable
 */
export function createGetWalletSignMesageObservable({notificationType, address}: {notificationType: string; address: string}): Observable<SignMessageObservableResult> {
  return defer(() => web3Api.postWeb3Start({notificationType, address})).pipe(
    tap((response) => {
      const {error} = response;
      if (error) {
        throw new Error(error.message);
      }
    }),
    map(({data}) => data),
    switchMap(({code: generalStartCode, msg: generalStartMessage}) =>
      defer(() => signMessage(generalStartMessage)).pipe(
        map((signedMessage) => ({
          signedMessage,
          generalStartCode,
          generalStartMessage,
        }))
      )
    )
  );
}

export interface SignMessageObservableResult {
  generalStartCode: string;
  generalStartMessage: string;
  signedMessage: string;
}
